.boton {
  --_box: var(--h-control-md);

  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: var(--_box);
  height: var(--_box);
  padding: 0;
  border-radius: var(--r-control);
  border: var(--bw-hair) solid transparent;
  background: transparent;
  color: var(--text-strong);
  cursor: pointer;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  transition:
    background var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard),
    transform var(--dur-fast) var(--ease-standard);
}
.boton[data-size="sm"] {
  --_box: var(--h-control-sm);
}
.boton[data-size="lg"] {
  --_box: var(--h-control-lg);
}
.boton[data-shape="square"] {
  border-radius: var(--r-md);
}

.boton[data-variant="bordered"] {
  background: var(--surface-card);
  border-color: var(--border-strong);
}
.boton[data-variant="soft"] {
  background: var(--surface-sunken);
}
.boton[data-variant="solid"] {
  background: var(--action-primary);
  border-color: var(--action-primary);
  color: var(--action-primary-text);
}
/* Tintes de estado sobre `bordered`: la regla de los tokens (50 fondo, 200 borde, 700 tinta). */
.boton[data-variant="bordered"][data-tone="success"] {
  background: var(--status-success-bg);
  border-color: var(--status-success-border);
  color: var(--text-success);
}
.boton[data-variant="bordered"][data-tone="brand"] {
  background: var(--surface-brand-faint);
  border-color: var(--border-brand-soft);
  color: var(--text-brand);
}
.boton[data-variant="bordered"][data-tone="danger"] {
  background: var(--status-danger-bg);
  border-color: var(--status-danger-border);
  color: var(--text-danger);
}
.boton[data-variant="bordered"][data-tone="neutral"] {
  background: var(--surface-sunken);
  border-color: var(--border-hair);
  color: var(--text-body);
}

@media (hover: hover) {
  .boton[data-variant="ghost"]:hover:enabled,
  .boton[data-variant="ghost"]:hover:not([aria-disabled]) {
    background: var(--action-quiet-hover);
    color: var(--text-brand);
  }
  .boton[data-variant="bordered"]:hover:enabled,
  .boton[data-variant="bordered"]:hover:not([aria-disabled]) {
    border-color: var(--border-hover);
  }
  .boton[data-variant="bordered"][data-tone="success"]:hover:enabled {
    background: var(--status-success-border);
    border-color: var(--status-success-border);
  }
  .boton[data-variant="bordered"][data-tone="brand"]:hover:enabled {
    background: var(--surface-brand-soft);
    border-color: var(--border-brand-soft);
  }
  .boton[data-variant="bordered"][data-tone="danger"]:hover:enabled {
    background: var(--status-danger-border);
    border-color: var(--status-danger-border);
  }
  .boton[data-variant="bordered"][data-tone="neutral"]:hover:enabled {
    background: var(--surface-muted);
    border-color: var(--border-hair);
  }
  .boton[data-variant="soft"]:hover:enabled,
  .boton[data-variant="soft"]:hover:not([aria-disabled]) {
    background: var(--action-quiet-active);
  }
  .boton[data-variant="solid"]:hover:enabled,
  .boton[data-variant="solid"]:hover:not([aria-disabled]) {
    background: var(--action-primary-hover);
    border-color: var(--action-primary-hover);
  }
}

.boton:active:enabled,
.boton:active:not([aria-disabled]) {
  transform: scale(0.97);
}
.boton[data-variant="ghost"]:active:enabled {
  background: var(--action-quiet-active);
}

.boton:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}

.boton:disabled,
.boton[aria-disabled="true"] {
  background: var(--action-disabled);
  color: var(--action-disabled-text);
  border-color: transparent;
  opacity: var(--action-disabled-opacity);
  box-shadow: none;
  cursor: not-allowed;
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  .boton {
    transition: none;
  }
}
